import React, { useState } from 'react';
import { ContactHeader } from './ContactHeader';
import { TabNavigation } from './ui/TabNavigation';
import { Toolbar } from './ui/Toolbar';
import { BasicInfoTab } from './tabs/BasicInfoTab';
import { SubaccountsTab } from './tabs/SubaccountsTab';
import { FinancialTab } from './tabs/FinancialTab';
import { CommunicationTab } from './tabs/CommunicationTab';
import { NotesTab } from './tabs/NotesTab';
import { BookingsTab } from './tabs/BookingsTab';
import { ClassesTab } from './tabs/ClassesTab';
import { CreditVoucherTab } from './tabs/CreditVoucherTab';
import { LessonCreditTab } from './tabs/LessonCreditTab';
import { DirectDebitTab } from './tabs/DirectDebitTab';
import { MembershipTab } from './tabs/MembershipTab';
import { TagsTab } from './tabs/TagsTab';
import { OnlineLoginTab } from './tabs/OnlineLoginTab';
import { AttachmentsTab } from './tabs/AttachmentsTab';
import { UserIcon, UsersIcon, DollarSignIcon, MessageSquareIcon, FileTextIcon, CalendarIcon, BookOpenIcon, TicketIcon, BookmarkIcon, CreditCardIcon, BadgeIcon, TagIcon, LockIcon, PaperclipIcon } from 'lucide-react';
export function ContactView({
  contact,
  onUpdate
}) {
  const [activeTab, setActiveTab] = useState('basic');
  const [isEditing, setIsEditing] = useState(false);
  const handleSave = updatedData => {
    onUpdate({
      ...contact,
      ...updatedData
    });
    setIsEditing(false);
  };
  const handleCancel = () => {
    setIsEditing(false);
  };
  const tabs = [{
    id: 'basic',
    label: 'Basic Info',
    icon: <UserIcon className="w-4 h-4" data-id="element-42" />
  }, {
    id: 'subaccounts',
    label: 'Subaccounts',
    icon: <UsersIcon className="w-4 h-4" data-id="element-43" />
  }, {
    id: 'financial',
    label: 'Financial',
    icon: <DollarSignIcon className="w-4 h-4" data-id="element-44" />
  }, {
    id: 'communication',
    label: 'Communication',
    icon: <MessageSquareIcon className="w-4 h-4" data-id="element-45" />
  }, {
    id: 'notes',
    label: 'Notes',
    icon: <FileTextIcon className="w-4 h-4" data-id="element-46" />
  }, {
    id: 'bookings',
    label: 'Bookings',
    icon: <CalendarIcon className="w-4 h-4" data-id="element-47" />
  }, {
    id: 'classes',
    label: 'Classes',
    icon: <BookOpenIcon className="w-4 h-4" data-id="element-48" />
  }, {
    id: 'creditVoucher',
    label: 'Credit Voucher',
    icon: <TicketIcon className="w-4 h-4" data-id="element-49" />
  }, {
    id: 'lessonCredit',
    label: 'Lesson Credit',
    icon: <BookmarkIcon className="w-4 h-4" data-id="element-50" />
  }, {
    id: 'directDebit',
    label: 'Direct Debit',
    icon: <CreditCardIcon className="w-4 h-4" data-id="element-51" />
  }, {
    id: 'membership',
    label: 'Membership',
    icon: <BadgeIcon className="w-4 h-4" data-id="element-52" />
  }, {
    id: 'tags',
    label: 'Tags',
    icon: <TagIcon className="w-4 h-4" data-id="element-53" />
  }, {
    id: 'onlineLogin',
    label: 'Online Login',
    icon: <LockIcon className="w-4 h-4" data-id="element-54" />
  }, {
    id: 'attachments',
    label: 'Attachments',
    icon: <PaperclipIcon className="w-4 h-4" data-id="element-55" />
  }];
  return <div className="flex flex-col w-full max-w-7xl mx-auto" data-id="element-56">
      <ContactHeader contact={contact} isEditing={isEditing} onSave={handleSave} onCancel={handleCancel} data-id="element-57" />
      <Toolbar data-id="element-58" />
      <div className="bg-white shadow rounded-lg mx-4 md:mx-6 mb-6" data-id="element-59">
        <TabNavigation tabs={tabs} activeTab={activeTab} onChange={setActiveTab} data-id="element-60" />
        <div className="p-4 md:p-6" data-id="element-61">
          {activeTab === 'basic' && <BasicInfoTab contact={contact} isEditing={isEditing} setIsEditing={setIsEditing} onUpdate={data => handleSave(data)} data-id="element-62" />}
          {activeTab === 'subaccounts' && <SubaccountsTab data-id="element-63" />}
          {activeTab === 'financial' && <FinancialTab contact={contact} isEditing={isEditing} data-id="element-64" />}
          {activeTab === 'communication' && <CommunicationTab contact={contact} data-id="element-65" />}
          {activeTab === 'notes' && <NotesTab contact={contact} data-id="element-66" />}
          {activeTab === 'bookings' && <BookingsTab contact={contact} data-id="element-67" />}
          {activeTab === 'classes' && <ClassesTab data-id="element-68" />}
          {activeTab === 'creditVoucher' && <CreditVoucherTab data-id="element-69" />}
          {activeTab === 'lessonCredit' && <LessonCreditTab data-id="element-70" />}
          {activeTab === 'directDebit' && <DirectDebitTab data-id="element-71" />}
          {activeTab === 'membership' && <MembershipTab data-id="element-72" />}
          {activeTab === 'tags' && <TagsTab contact={contact} data-id="element-73" />}
          {activeTab === 'onlineLogin' && <OnlineLoginTab data-id="element-74" />}
          {activeTab === 'attachments' && <AttachmentsTab data-id="element-75" />}
        </div>
      </div>
    </div>;
}